import React, { FC } from "react";
import { Link } from "react-router-dom";
import { Layout } from "antd";
import { Logo } from "./logo";
import { UserMenu } from "./user-menu";
import { MainMenu } from "./main-menu";
import { CurrentUser } from "../../graphql/types";
import styles from "./header.module.css";
import { HeaderNotificationContainer } from "./header-notification-container";

export type HeaderProps = {
  currentUser: CurrentUser;
  onClickLogout: () => void;
};

const { Header: AHeader } = Layout;

export const Header: FC<HeaderProps> = ({ currentUser, onClickLogout }) => {
  return (
    <AHeader className={styles.header}>
      {currentUser && (
        <div className={styles.content}>
          <div className={styles.container}>
            <div className={styles.logo}>
              <Link to="/">
                <Logo />
              </Link>
            </div>
            <div className={styles.menu}>
              <MainMenu />
            </div>
          </div>
          <div>
            <HeaderNotificationContainer />
          </div>
          <div className={styles.user}>
            <UserMenu user={currentUser} onClickLogout={onClickLogout} />
          </div>
        </div>
      )}
    </AHeader>
  );
};
